import React, { useState, useEffect } from "react";
import Modal from "../../../../components/ui/Modal";
import Input from "../../../../components/ui/Input";
import Button from "../../../../components/ui/Button";

// The modal now accepts an optional 'eventToEdit' prop
const CreateEventModal = ({ isOpen, onClose, onSave, eventToEdit }) => {
  /* New State for Price & Margin */
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [type, setType] = useState("Live");
  const [price, setPrice] = useState("");
  const [margin, setMargin] = useState("");

  const isEditMode = !!eventToEdit;

  useEffect(() => {
    if (isEditMode && isOpen) {
      setTitle(eventToEdit.title);
      setDate(eventToEdit.date);
      setType(eventToEdit.type);
      setPrice(eventToEdit.priceETB || "");
      setMargin(eventToEdit.margin || "");
    } else {
      setTitle("");
      setDate("");
      setType("Live");
      setPrice("");
      setMargin("");
    }
  }, [isOpen, eventToEdit, isEditMode]);

  const handleSaveClick = () => {
    if (!title || !date) return;

    const eventData = {
      id: isEditMode ? eventToEdit.id : Date.now(),
      title,
      date,
      type,
      priceETB: Number(price),
      margin: Number(margin),
      totalPrice: Number(price) + Number(margin),
      ticketsSold: isEditMode ? eventToEdit.ticketsSold : 0,
      status: "Upcoming",
    };
    onSave(eventData);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isEditMode ? "Edit Event" : "Create New Event"}
    >
      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium text-slate-700">
            Event Title
          </label>
          <Input
            placeholder="e.g., Unity Concert"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-sm font-medium text-slate-700">Date</label>
            <Input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700">Type</label>
            <select
              className="w-full mt-1 p-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option>Live</option>
              <option>Virtual</option>
            </select>
          </div>
        </div>

        {/* Pricing Section */}
        <div className="grid grid-cols-2 gap-4 bg-slate-50 p-4 rounded-lg border border-slate-100">
          <div>
            <Input
              label="Ticket Price (ETB)"
              type="number"
              placeholder="0.00"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
          <div>
            <Input
              label="Your Margin (ETB)"
              type="number"
              placeholder="0.00"
              value={margin}
              onChange={(e) => setMargin(e.target.value)}
            />
          </div>
          <div className="col-span-2 flex justify-between items-center pt-2 border-t border-slate-200 mt-2">
            <span className="font-semibold text-slate-700">Total Ticket Price:</span>
            <span className="text-xl font-bold text-primary">
              {(Number(price) + Number(margin)).toLocaleString()} ETB
            </span>
          </div>
        </div>

        <div className="flex justify-end pt-4 space-x-3">
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveClick}>
            {isEditMode ? "Save Changes" : "Save Event"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CreateEventModal;
